import PropTypes from 'prop-types';
import React from 'react';
import dayjs from 'dayjs';

import BackgroundImage from '$partials/media/background-image';
import Link from '$partials/global/link';
import IconArrowRight from '$partials/icons/icon-arrow-right';
import { formatUrlWithActiveFund } from '$utilities/format';

const EventItem = ({
    className = '',
    listingImage,
    listingText,
    eventDate,
    eventLocation,
    title,
    openToModal = false,
    url: originalUrl,
    type
}) => {
    const Component = openToModal ? Link : 'a';
    const url = formatUrlWithActiveFund(originalUrl);

    return (
        <article className={`expand-interaction ${className} md:flex`}>
            <figure
                className='md:w-3/12 aspect-3/2 sm:aspect-9/5 overflow-hidden relative rounded-lg md:order-2'>
                <BackgroundImage
                    containerClassName=''
                    {...listingImage} />
            </figure>

            <div className='md:w-2/12 max-sm:bg-white pt-30 sm:pt-20 md:pt-0 rounded-b-lg sm:px-0 md:order-1 type-style-7'>
                <p className='mb-5'>{type}</p>
                <div className='inline-block type-style-7'>
                    <span className='pb-5 md:pb-8'>{dayjs(eventDate).format('DD.MM.YY')}</span>
                    <span className='pb-5 mx-5 md:hidden'>&#183;</span>
                    <span className='pb-5 md:hidden'>{dayjs(eventDate).format('Ha')}</span>
                    <p className='py-5 hidden md:block'>{dayjs(eventDate).format('hA')}</p>
                </div>
                <p className='hidden md:block type-style-7'>{eventLocation}</p>
                <button
                    className='hidden md:block bg-grey w-fit px-12 py-8 rounded-full mt-15 arrow-button'
                    type='button'>
                    <IconArrowRight />
                </button>
            </div>
            <div className='md:w-6/12 max-sm:bg-white pt-10 md:py-0 rounded-b-lg sm:px-0 md:order-3 md:ml-auto md:pr-100'>
                <h3 className='type-style-4'>
                    <Component
                        className='expand-interaction__action'
                        href={url}>
                        {title}
                    </Component>
                </h3>
                {listingText &&
                      <p className='mt-10'>
                          {listingText}
                      </p>
                }
            </div>

        </article>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

const propTypes = {
    className: PropTypes.string,
    listingImage: PropTypes.object,
    listingText: PropTypes.string,
    eventDate: PropTypes.string,
    style: PropTypes.string,
    title: PropTypes.string,
    url: PropTypes.string,
    eventLocation: PropTypes.string,
    type: PropTypes.string,
    openToModal: PropTypes.bool,
};

EventItem.propTypes = propTypes;

export default EventItem;
